module.exports = __webpack_public_path__ + "media/activity/star-half-55421d1e.svg";